module.exports = __webpack_public_path__ + "img/travelcard-logo.ccd6c631.svg";